import {Routes} from 'constants/routes';

import {faEnvelope, faLock} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Button from 'components/Button/Button';
import Icon from 'components/Icon/Icon';
import {ErrorMessage, Field, Formik, Form} from 'formik';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {useNavigate, Link} from 'react-router-dom';
import {loginUserACS} from 'store/app/requestAC';
import {LoginDTO} from 'typescript/dto/authDto';

import loginSchema from './loginValidation';
import './Login.scss';

const Login = () => {
  const initialValues: LoginDTO = {
    email: '',
    password: '',
  };

  const dispatch = useSetGlobalState();
  const navigate = useNavigate();

  const {isLoading} = useGlobalState((state) => state.app);

  const handleSubmit = (values: LoginDTO) => {
    dispatch(
      loginUserACS({
        loginData: {
          email: values.email.trim(),
          password: values.password,
        },
        navigate,
      }),
    );
  };

  return (
    <div className="login-page">
      <div className="login-page__cloud-up" />
      <div className="login-page__header">
        <Link to={Routes.HOME}>
          <Icon icon="login_logo" />
        </Link>
      </div>
      <div className="login-page__container">
        <div className="login-page__welcome">
          <h1 className="login-page__welcome-title">Welcome!</h1>
          <h2 className="login-page__welcome-subtitle">Get the best from our app</h2>
        </div>
        <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={loginSchema}>
          <Form className="login-page__form">
            <div className="login-page__form-control">
              <label className="login-page__form-label">
                <FontAwesomeIcon icon={faEnvelope} />
                <Field name="email" placeholder="email@example.com" className="login-page__form-input" />
              </label>
              <ErrorMessage className="login-page__form-error" component="span" name="email" />
            </div>
            <div className="login-page__form-control">
              <label className="login-page__form-label">
                <FontAwesomeIcon icon={faLock} />
                <Field name="password" type="password" placeholder="●●●●●●●●" className="login-page__form-input" />
              </label>
              <ErrorMessage className="login-page__form-error" component="span" name="password" />
            </div>
            <div className="login-page__forgot-password">
              <Link to={Routes.FORGOT_PASSWORD} className="login-page__forgot-password-link">
                Forgot Password?
              </Link>
            </div>
            <div className="login-page__cloud-down">
              <div className="login-page__actions">
                <Button className="login-page__signin-btn" variant="tertiary" type="submit" disabled={isLoading}>
                  {isLoading ? <div className="spinner-border" /> : 'Sign In'}
                </Button>
              </div>
            </div>
          </Form>
        </Formik>
        <div className="login-page__footer" />
      </div>
    </div>
  );
};

export default Login;
